import type {
  SolutionColorPalette,
  SolutionCSSColorPalette,
  SolutionColors,
} from "@smartsuite/react-ui";
import { defaultSolutionColor, solutionColors } from "@smartsuite/react-ui";

function getSolutionColorVariables(
  colorPalette: SolutionColorPalette,
): SolutionCSSColorPalette {
  return {
    "solution-primary-color": colorPalette.primary,
    "solution-secondary-color": colorPalette.secondary,
    "solution-hover-color": colorPalette.hover,
    "solution-highlight-color": colorPalette.highlight,
  };
}

export function getSolutionCSSColorPalette(
  logoColor?: SolutionColors,
): SolutionCSSColorPalette {
  const defaultColorPalette = defaultSolutionColor;
  if (logoColor === undefined) {
    return getSolutionColorVariables(defaultColorPalette);
  }
  const colorPalette = solutionColors.find(
    (color) => logoColor === color.primary,
  );
  return getSolutionColorVariables(colorPalette ?? defaultColorPalette);
}

export function hexToRgb(hex: string): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result !== null
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ].join(", ")
    : "0, 0, 0";
}
